<div class="head">
  <ng-content></ng-content>
</div>
